(ns app.survey.login.email.sub
  (:require
   [common.util :as cu]
   [re-frame.core :as rf]))

(rf/reg-sub
 ::state
 (fn [db [_]]
   (get db ::state)))

(rf/reg-sub
 ::tries-left
 (fn [db _]
   (get db ::tries-left)))

(rf/reg-sub
 ::validated?
 (fn [db [_]]
   (get db ::validated?)))

(rf/reg-sub
 ::masked-email
 (fn [db [_]]
   (get db ::masked-email)))


(rf/reg-sub
 ::email-token
 (fn [db [_]]
   (get db ::email-token)))

(rf/reg-sub
 ::valid-verification-tokens?
 :<-
 [::email-token]
 (fn [email-token _]
   (let [valid? (not (cu/blank-value? (str email-token)))]
     valid?)))

(rf/reg-sub
 ::valid-email-token?
 :<-
 [::email-token]
 (fn [email-token _]
   (not (cu/blank-value? (str email-token)))))
